module.exports = __webpack_public_path__ + "static/media/SNX-ETH.a9ee27c2.png";